import { getLevel2, lvl2_default } from './levels';
import { PageTrackingInfo } from 'api/Tracking/Tracking';

export const TRACKING_PAGES: { [k: string]: () => PageTrackingInfo } = {
  CONNEXION: () => ({
    name: 'Connexion::depot',
    level2: getLevel2(),
  }),
  INSCRIPTION: () => ({
    name: 'Inscription::depot',
    level2: getLevel2(),
  }),
  RESET_PASSWORD: () => ({
    name: 'PasswordOublie::depot',
    level2: getLevel2(),
  }),
  VERTICAL_CHOICE_PART: () => ({
    name: 'etape_0_type_vehicule ',
    level2: lvl2_default,
    customVars: {
      '38': '[etape_0_type_vehicule]',
    },
  }),
  VERTICAL_CHOICE_PRO: () => ({
    name: 'pro_etape_0_type_vehicule ',
    level2: lvl2_default,
    customVars: {
      '38': '[pro_etape_0_type_vehicule]',
    },
  }),
  IMMAT_PART: () => ({
    name: 'etape_0_immat',
    nameError: 'etape_0_immat_erreur',
    level2: lvl2_default,
    customVars: {
      '38': '[etape_0_immat]',
    },
  }),
  IMMAT_PRO: () => ({
    name: 'pro_etape_0_immat',
    nameError: 'pro_etape_0_immat_erreur',
    level2: lvl2_default,
    customVars: {
      '38': '[pro_etape_0_immat]',
    },
  }),
  VERSION_PART: () => ({
    name: 'etape_1_selection_du_vehicule',
    nameError: 'etape_1_selection_du_vehicule_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[etape_1_selection_du_vehicule]',
    },
  }),
  VERSION_PRO: () => ({
    name: 'pro_etape_1_selection_du_vehicule',
    nameError: 'pro_etape_1_selection_du_vehicule_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[pro_etape_1_selection_du_vehicule]',
    },
  }),
  EQUIPEMENT_PART: () => ({
    name: 'etape_2_description_du_vehicule',
    nameError: 'etape_2_description_du_vehicule_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[etape_2_description_du_vehicule]',
    },
  }),
  EQUIPEMENT_PRO: () => ({
    name: 'pro_etape_2_description_du_vehicule',
    nameError: 'pro_etape_2_description_du_vehicule_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[pro_etape_2_description_du_vehicule]',
    },
  }),
  PHOTOS_PART: () => ({
    name: 'etape_3_photos',
    nameError: 'etape_3_photos_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[etape_3_photos]',
    },
  }),
  PHOTOS_PRO: () => ({
    name: 'pro_etape_3_photos',
    nameError: 'pro_etape_3_photos_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[pro_etape_3_photos]',
    },
  }),
  CONTACT_PART: () => ({
    name: 'etape_4_coordonnees',
    nameError: 'etape_4_coordonnees_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[etape_4_coordonnees]',
    },
  }),
  CONTACT_PRO: () => ({
    name: 'pro_etape_4_coordonnees',
    nameError: 'pro_etape_4_coordonnees_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[pro_etape_4_coordonnees]',
    },
  }),
  VALIDATION_PART: () => ({
    name: 'etape_5_validationtelephone',
    nameError: 'etape_5_validationtelephone_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[etape_5_validationtelephone]',
    },
  }),
  PRIX_PART: () => ({
    name: 'etape_6_prix',
    nameError: 'etape_6_prix_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[etape_6_prix]',
    },
  }),
  PRIX_PRO: () => ({
    name: 'pro_etape_6_prix',
    nameError: 'pro_etape_6_prix_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[pro_etape_6_prix]',
    },
  }),
  OPTIONS_PART: () => ({
    name: 'etape_7_options_de_parution',
    nameError: 'etape_7_options_de_parution_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[etape_7_options_de_parution]',
    },
  }),
  CONFIRMATION_PRO: () => ({
    name: 'pro_confirmation_depot',
    nameError: 'pro_confirmation_depot_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[pro_confirmation_depot]',
    },
  }),
  MODIFICATION_VERSION: () => ({
    name: 'modification_selection_du_vehicule',
    nameError: 'modification_selection_du_vehicule_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[modification_selection_du_vehicule]',
    },
  }),
  MODIFICATION_VERSION_PRO: () => ({
    name: 'modification_pro_selection_du_vehicule',
    nameError: 'modification_pro_selection_du_vehicule_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[modification_pro_selection_du_vehicule]',
    },
  }),
  MODIFICATION_DESCRIPTION: () => ({
    name: 'modification_description_du_vehicule',
    nameError: 'modification_description_du_vehicule_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[modification_description_du_vehicule]',
    },
  }),
  MODIFICATION_DESCRIPTION_PRO: () => ({
    name: 'modification_pro_description_du_vehicule',
    nameError: 'modification_pro_description_du_vehicule_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[modification_pro_description_du_vehicule]',
    },
  }),
  MODIFICATION_PHOTOS: () => ({
    name: 'modification_photos',
    nameError: 'modification_photos_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[modification_photos]',
    },
  }),
  MODIFICATION_PHOTOS_PRO: () => ({
    name: 'modification_pro_photos',
    nameError: 'modification_pro_photos_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[modification_pro_photos]',
    },
  }),
  MODIFICATION_COORDONEES: () => ({
    name: 'modification_coordonnees',
    nameError: 'modification_coordonnees_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[modification_coordonnees]',
    },
  }),
  MODIFICATION_COORDONEES_PRO: () => ({
    name: 'modification_pro_coordonnees',
    nameError: 'modification_pro_coordonnees_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[modification_pro_coordonnees]',
    },
  }),
  MODIFICATION_VALIDATION_SMS: () => ({
    name: 'modification_validationSMS',
    nameError: 'modification_validationSMS_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[modification_validationSMS]',
    },
  }),
  MODIFICATION_PRIX: () => ({
    name: 'modification_prix',
    nameError: 'modification_prix_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[modification_prix]',
    },
  }),
  MODIFICATION_PRIX_PRO: () => ({
    name: 'modification_pro_prix',
    nameError: 'modification_pro_prix_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[modification_pro_prix]',
    },
  }),
  RENOUVELLEMENT: () => ({
    name: 'renouvellement_options_de_parution',
    nameError: 'renouvellement_options_de_parution_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[renouvellement_options_de_parution]',
    },
  }),
  VISIBILITE: () => ({
    name: 'visibilite_options_de_parution',
    nameError: 'visibilite_options_de_parution_erreur',
    level2: getLevel2(),
    customVars: {
      '30': '[vendeur]',
      '38': '[visibilite_options_de_parution]',
    },
  }),
};
